'use strict';

const h = require('phy');

const SignInComponent = require('../sign_in_component');

const signInComponentWrapper = props => {
  return h(
    '.sign-in-container',
    h(SignInComponent, props)
  );
};

module.exports = signInComponentWrapper;
